<div class="mc-avatar-tooltip-container" [matTooltip]="name" [matTooltipDisabled]="disabledTooltip || !name">
  <div *ngIf="showAvatar" class="mc-avatar-container">
    <img alt="Flare Online Logo" class="mc-avatar-image" src="assets/images/madcap-flare-online-logo.svg">
  </div>
  <span *ngIf="showName" class="mc-avatar-name">{{ name }}</span>
</div>